import { confirmBox } from "@/utils/messageBox.js";
import * as ws from "@/utils/websocket";
import { ElMessage, ElNotification } from "element-plus";
import { bus } from "@/utils/mitt.js";

// const getWebsocketResult = (res, getResult = () => {}) => {
const getWebsocketMessage = (res) => {
  console.log(res);
  if (res !== "pong") {
    let result = JSON.parse(res);
    let message;
    try {
      message = JSON.parse(result.message);
    } catch (error) {
      message = result.message;
    }
    if (result.aiType == 1) {
      handleTranscribeMessage(message);
    } else if (result.aiType == 2) {
      bus.emit("refresh-token");
    }
    bus.emit("get-websocket-result", { message: message });
  }
};
const handleTranscribeMessage = (message) => {
  console.log("🚀 ~ handleTranscribeMessage ~ message:", message);
  ElNotification({
    title: "录音转录已完成",
    dangerouslyUseHTMLString: true,
    message: `您的<a href="/${message.projectUid}/interview/${message.interviewUid}?r=true" style="color: #2e83d3;cursor:pointer">${message.name}</a><span>
    转录已完成，您可点击查看</span>`,
    duration: 0,
    type: "success",
  });
};

export { getWebsocketMessage };
